import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { useSnackbar } from '../../../context/SnackbarContext';
import { useTranslation } from 'react-i18next';
import UserAutocomplete from '../controls/UserAutocomplete';
import { useUpdateHistoryEntry } from '../../../hooks/history/useUpdateHistoryEntry';

export default function ChangeUserForm({ historyEntry = null, successCallback = null, open, onClose, title = 'Change User' }) {
  const { t } = useTranslation('common'); 

  const { update } = useUpdateHistoryEntry(successCallback);
  const { showSnackbar } = useSnackbar();

  const [userId, setUserId] = React.useState(historyEntry.user_id);

  const handleSave = async () => {
    if (!userId) {
      showSnackbar(t('history.messages.doctor_required'), "warning");
      return;
    }
    try {
      await update(historyEntry.id, { 
        user_id: userId,
      });
      showSnackbar(t('history.messages.doctor_update_success'), "success");
      onClose();         // close dialog
    } catch (err) {
      showSnackbar(t('history.messages.doctor_update_fail'), "error");
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Dialog onClose={handleCancel} open={open} disableRestoreFocus>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={1}>
          <UserAutocomplete
            label="Attending Doctor"
            value={userId}
            onChange={(id) => setUserId(id)} 
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSave}>Save</Button>
        <Button onClick={handleCancel}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}